import AchievementsDataset from "../../components/game-views/datasets/achievements_dataset";
import processAchievementCriteriaArr from "./process_achievement_criteria_arr";
import determineAchievementMonthsText from "../../components/game-views/objectsStatus/determine_achievement_months_text";
import determineCreditScore from "../../components/game-views/objectsEndOfTurn/determine_credit_score";

export const checkForAchievements = (gameData, savingsInfo, creditCardInfo, 
        summaryInvestments, investmentMaster, nbrMonthsPlayed, creditScore, monthsPerTurn, 
        moneyMgmtTestArr, timeWizardInfo, processName, achievementArr) => {
    // if achievementArr is undefined, then process all achievements, else only
    // process the achievements that are found in the achievementArr.  
    // if not undefined, achievementArr is a copy of the data in AchievementsDataset for
    //  all achievements that are supposed to be processed
    if (!achievementArr || achievementArr.length === 0){
        achievementArr = AchievementsDataset;
    }
    let newAchievementArr = [];
    for (let i=0; i<achievementArr.length; i++){
        const achievementInfo = achievementArr[i];
        let achievementIndx = 
            gameData.achievementArr.findIndex(elem => elem.achievementID === achievementInfo.achievementID);
        let achievementObj = {};
        let newAchievement = false;
        if (achievementIndx === -1){
            newAchievement = true;
            achievementObj = {achievementID: achievementInfo.achievementID, 
                achievementTitle: achievementInfo.achievementTitle,
                actualMonths: "0", earned: false };
        }else{
            achievementObj = gameData.achievementArr[achievementIndx];
        }
        // skip to next entry in array if this achievement has already been earned
        if (achievementObj.earned === true){
            continue
        }
        let creditCardBalance = 0;
        if (creditCardInfo.currentlyActive && creditCardInfo.currentlyActive === true){
            if (creditCardInfo.prevPeriodOutstandBalance){
                // using previous period for outstanding credit card balance because
                // it accounts for manual payments and excludes cases where the
                // player is checking 'mid-turn'.
                creditCardBalance = creditCardInfo.prevPeriodOutstandBalance;
            }
        }else{
            creditCardBalance = "N/A";
        }
        const creditScore = determineCreditScore(creditCardInfo, gameData.loanTable,
                gameData.currentGameDate, gameData.gameNbrMonths, timeWizardInfo ).creditScore;
       // if (achievementInfo.achievementID === "J=3"){
       //     debugger
       // }
        const checkAchievementArr = processAchievementCriteriaArr(achievementInfo.criteriaArr, 
                processName, gameData, savingsInfo, creditCardBalance, summaryInvestments, investmentMaster,
                nbrMonthsPlayed, creditScore, moneyMgmtTestArr);
       // if (achievementInfo.achievementID === "J-3"){
       //    debugger
       // }
        let earnedAchievement = true;
        for (let j=0; j<checkAchievementArr.length; j++){
            if (checkAchievementArr[j].earnedAchievement === false){
                earnedAchievement = false;
                break;
            }
        }
        // if (achievementInfo.achievementID === "J-3"){
        //      debugger
        // }
        let monthCriteriaCheck = false;
        let updateAchievement = false;
        let achievementJustEarned = false;
        let actualMonths = achievementObj.actualMonths;
    //    if (achievementInfo.achievementID === "G-4"){
    //        debugger
    //    }
        if (earnedAchievement === true){
            if (achievementInfo.monthCriteria.monthType !== "none"){
                const monthCriteriaCheckObj = determineAchievementMonthsText(gameData.achievementArr, 
                    achievementInfo.monthCriteria, achievementInfo.achievementID, nbrMonthsPlayed,
                    processName, monthsPerTurn);
                monthCriteriaCheck = monthCriteriaCheckObj.passedMonthCriteria;
                actualMonths = monthCriteriaCheckObj.actualMonths;
            }else{
                monthCriteriaCheck = true;
            }
            if (monthCriteriaCheck === true){
                achievementObj.earned = true;
                achievementJustEarned = true;
                updateAchievement = true;
            }else{
                if (newAchievement === false){
                    updateAchievement = true;
                }else{
                    if (achievementInfo.monthCriteria.monthType === "consecutive"){
                        updateAchievement = true;
                    }
                }
            }
        }else{
            if (newAchievement === false){
                if (achievementInfo.monthCriteria.monthType === "consecutive"){
                    actualMonths = 0;
                    updateAchievement = true;
                }
            }
        }
        if (updateAchievement === true){
            achievementObj.actualMonths = actualMonths.toString();
            if (achievementJustEarned === true){
                newAchievementArr.push(achievementInfo);
            }
            if (newAchievement === true){
                gameData.achievementArr.push(achievementObj);
            }else{
                gameData.achievementArr[achievementIndx] = achievementObj;
            }
        }
    }
    return newAchievementArr;
}
export default checkForAchievements;